<template>
  <div class="resetPassword">
    <!-- 表单部分 -->
    <van-form validate-first @failed="onFailed" @submit="onSubmit">
      <!-- 通过 pattern 进行正则校验 -->
      <div class="login_label">注册山国会员</div>
      <van-field
        v-model="username"
        required
        name="username"
        label="姓名："
        placeholder="请输入姓名"
        scroll-to-error
        clearable
        :error="false"
        :maxlength="5"
        :rules="[
          {
            message: '姓名不能为空',
            required: true,
          },
        ]"
      />
      <van-field
        v-model="mobile"
        name="mobile"
        label="手机号码： "
        required
        type="number"
        placeholder="请输入手机号码"
        clearable
        :error="false"
        :rules="[
          {
            pattern: mobilePattern,
            message: '手机号码格式错误',
            required: true,
          },
        ]"
      />
      <van-field
        v-model="weixinNum"
        name="weixinNum"
        label="微信号："
        placeholder="请输入微信号码"
        clearable
      />

      <van-field
        v-model="smsCode"
        label="验证码："
        :error="false"
        :maxlength="4"
        required
        :rules="[
          {
            message: '短信校验码不能为空!',
            required: true,
          },
        ]"
        clearable
        name="smsCode"
        placeholder="请输入验证码"
      >
        <div slot="button">
          <div v-if="showCountDown">
            <van-count-down
              :time="smsTime"
              format="ss"
              @finish="countDownFinish"
            />
          </div>
          <div v-else class="smsCodeText" @click="sendSmsCode">获取验证码</div>
        </div>
      </van-field>
      <!-- 登陆按钮 -->
      <div class="btn-wrap" style="margin-top: 16px">
        <van-button round block type="info" class="btn" native-type="submit"
          >确定</van-button
        >
      </div>
    </van-form>
    <van-dialog
      class="successDialog"
      confirm-button-text="返回首页"
      cancel-button-text="关闭提示"
      v-model="showDialog"
      @confirm="toHome"
      show-cancel-button
    >
      <van-icon
        class="successIcon"
        name="checked"
        size="50px"
        color="#18B75D"
      />
      <div>会员注册成功</div>
    </van-dialog>
  </div>
</template>

<script>
import { sendSmsCode, registered } from "@/api/user";
import { Toast } from "vant";

export default {
  name: "registerMember",
  data() {
    return {
      username: "",
      mobile: "",
      weixinNum: "",
      smsCode: "",
      showDialog: false,
      mobilePattern: /^[1]([3-9])[0-9]{9}$/, //正则匹配手机号码
      usernamePattern: "",
      smsTime: 60 * 1000,
      showCountDown: false, //是否显示倒计时
      shopInfo: "",
    };
  },
  created() {
    this.loadComments();
  },
  methods: {
    loadComments() {
      let _this = this;
      _this.getCountDownTime();
      let s = sessionStorage.getItem("shopInfo");
      this.shopInfo = s ? JSON.parse(s) : "";
    },
    //获取时间倒计时
    getCountDownTime() {
      let _this = this;
      let sendTime = sessionStorage.getItem("sendTime")
        ? parseInt(sessionStorage.getItem("sendTime"))
        : 0;
      let nowTime = new Date().getTime();
      const diffTime = nowTime - sendTime;
      if (diffTime >= 60 * 1000) {
        _this.showCountDown = false;
      } else {
        _this.smsTime = _this.smsTime - diffTime;
        _this.showCountDown = true;
      }
    },
    toHome() {
      this.$router.push("/");
    },
    //发送短信验证码
    sendSmsCode() {
      let _this = this;
      if (_this.mobile == null || _this.mobile == "") {
        Toast.fail("手机号不能为空!");
        return;
      }
      if (!this.mobilePattern.test(_this.mobile)) {
        Toast.fail("手机号格式有误!");
        return false;
      }
      sendSmsCode(_this.mobile, 1);
      _this.showCountDown = true;
      sessionStorage.setItem("sendTime", new Date().getTime());
    },
    onFailed(errorInfo) {
      console.log("failed", errorInfo);
    },
    //表单提交
    onSubmit(values) {
      let _this = this;
      let param = {
        code: values.smsCode,
        mobile: values.mobile,
        username: values.username,
        weixinNum: values.weixinNum,
        shopCode: _this.shopInfo.shopCode,
        operator: _this.shopInfo.id,
      };
      registered(param).then((resp) => {
        if (resp.data.code == "0000") {
          _this.showCountDown = false;
          _this.smsTime = 60 * 1000;
          _this.mobile = "";
          _this.username = "";
          _this.smsCode = "";
          _this.weixinNum = "";
          _this.showDialog = true;
        } else {
          Toast.fail(resp.data.msg);
        }
      });
    },
    //改变计时状态
    countDownFinish() {
      this.showCountDown = false;
    },
  },
};
</script>


<style lang="less" scoped>
@import url("../../assets/css/resetPassword.less");
</style>